<template>
  <div>
    <el-overlay-loading :loading="loading" />
    <div style="position: relative">
      <label v-if="showList" class="list-select-lable">{{ label }}</label>
      <v-simple-table
        v-if="showList"
        :class="`pt-1 table-input-box ${disabled ? 'disabled' : ''}`"
        dense
      >
        <template v-if="updating">
          <thead>
            <tr>
              <th colspan="3">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </th>
            </tr>
          </thead>
        </template>
        <tbody>
          <tr>
            <td colspan="3" style="overflow: hidden">
              <div style="float: left; padding-top: 3px">
                <strong>{{ `Viso: ${elValue.length}` }}</strong>
              </div>
              <div style="float: right">
                <el-button
                  small
                  outlined
                  class="select-input-btn mr-1"
                  color="primary"
                  @click.native="actionAll()"
                >
                  {{ $t(added ? 'Pašalinti visas' : 'Pridėti visas') }}
                </el-button>
              </div>
            </td>
          </tr>
          <tr v-for="(subItem, index) in paginatedItems" :key="subItem.value">
            <td class="pa-0 pl-2" style="max-width: 48px; width: 48px">
              {{ index + 1 + (currentPage - 1) * perPage }}
            </td>
            <td
              style="max-width: 20px; width: 20px; padding-left: 10px"
              v-if="!disabled"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    dense
                    class="table-action mx-1"
                    v-bind="attrs"
                    v-on="on"
                    @click="actionItem(subItem)"
                  >
                    {{ added ? 'mdi-delete-outline' : 'mdi-plus' }}
                  </v-icon>
                </template>
                <div class="tooltip-text">
                  {{ $t(added ? 'Pašalinti' : 'Pridėti') }}
                </div>
              </v-tooltip>
            </td>
            <td>{{ getItem(subItem) }}</td>
          </tr>
        </tbody>
      </v-simple-table>
      <div>
        <v-pagination
          class="py-2 px-4"
          v-model="currentPage"
          :total-visible="10"
          :length="pages"
          @input="paginate()"
        ></v-pagination>
        <v-select
          v-if="$vuetify.breakpoint.mdAndUp"
          outlined
          dense
          hide-details
          background-color="white"
          v-model="perPage"
          :items="[10, 25, 50, 100]"
          style="position: absolute; width: 90px; bottom: 10px; right: 0"
        />
        <div style="text-align: -webkit-center" v-else>
          <v-select
            outlined
            dense
            hide-details
            background-color="white"
            v-model="perPage"
            :items="[10, 25, 15, 100]"
            style="width: 90px"
            class="mb-4"
          />
        </div>
      </div>
    </div>
    <!-- modals -->
    <modal-custom
      :title="$t('Pranešimas')"
      :text="confirmQuestion"
      trueText="Taip"
      falseText="Ne"
      :loading="loading"
      v-model="showConfirmModal"
      @confirmData="confirmApprove"
    />
  </div>
</template>

<script>
import ModalCustom from '@/components/modals/ModalCustom'

export default {
  name: 'ElCompositeListSelect',
  components: { ModalCustom },
  mixins: [],
  props: {
    label: String,
    items: [Object, Array],
    itemtext: String,
    itemvalue: String,
    value: [String, Number, Object, Array, Boolean],
    disabled: Boolean,
    added: Boolean,
    validateKey: String,
    updating: Boolean,
    lock: Boolean,
  },
  data() {
    return {
      itemLoading: false,
      filter: '',
      loading: false,
      addInput: '',
      perPage: 100,
      currentPage: 1,
      confirmQuestion: '',
      showConfirmModal: false,
    }
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    paginatedItems() {
      const start = (this.currentPage - 1) * this.perPage
      const end = start + this.perPage
      return this.elValue.slice(start, end)
    },
    pages() {
      return Math.ceil(this.elValue.length / this.perPage)
    },
    showList() {
      return true
    },
    elValue: {
      get() {
        return this.value
      },
      set(elValue) {
        this.$emit('input', elValue)
      },
    },
  },
  created() {},
  watch: {
    updating(newVal) {
      if (newVal) {
        this.currentPage = 1
      }
    },
  },
  methods: {
    actionItem(item) {
      this.$emit('action-item', item)
    },
    actionAll() {
      if (this.added) {
        this.confirmQuestion = 'Ar tikrai norite pašalinti visas?'
      } else {
        this.confirmQuestion = 'Ar tikrai norite pridėti visas?'
      }
      this.showConfirmModal = true
    },
    confirmApprove() {
      this.showConfirmModal = false
      if (this.added) {
        this.$emit('action-all', this.elValue)
      } else {
        this.$emit(
          'action-all',
          this.elValue.map((item) => item.value)
        )
      }
    },
    paginate() {
      this.itemLoading = true
      this.$nextTick(() => {
        this.itemLoading = false
      })
    },
    getItem(subItem) {
      if (this.items) {
        let val = this.added ? subItem : subItem.value
        let item = this.items.lt.find((element) => {
          return element.value == val
        })
        return item ? item.text : ''
      }
      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
.table-input-box {
  margin-top: 25px;
  border: 1px solid #198677;
  max-height: 450px;
  overflow: auto;
  &.disabled {
    border: 1px solid #949494;
    border-top: none;
    background-color: #e5e5e5;
    :hover {
      background-color: #e5e5e5;
    }
  }
}
.list-select-lable {
  background-color: white;
  font-size: 12px;
  color: #686868;
  line-height: 12px;
  position: absolute;
  left: 10px;
  top: -5px;
}

.select-input-btn {
  height: 25px !important;
  min-width: 23px !important;
  padding: 0px 4px 0px 4px !important;
}
</style>
